import Result from '@/modules/core/models/result.class'
import axios from 'axios'
import {
  mapConstituencyVoterFromConstituencyVoterDTO,
  mapConstituencyVotersDtoFromConstituencyVotersDtoDTO,
  mapVoterFromVoterDTO
} from '../mappers/voter.mapper'

import years from '@/assets/voter/years.json'
import type VoterDto from '../dtos/voter.dto'
import type { ConstituencyRegisteredVoter, VoterCount } from '../models/registered-voters'
import type ConstituencyVoterDto from '@/modules/voter/dtos/constituency-voter.dto'

export default class RegisteredVoterApiService {
  async getVoters() {
    try {
      const responses = await Promise.all(
        years.map((e: string) => {
          return axios.get<VoterDto>(`/data/voters/${e}.json`)
        })
      )
      const voters = []
      for (const response of responses) {
        const voter = response.data
        voters.push(voter)
      }

      const mappedVoters = voters.map((dto) => mapVoterFromVoterDTO(dto))

      return Result.success(mappedVoters)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }

  async getConstituencyVoters(constituency: string) {
    try {
      const responses = await axios.get<ConstituencyVoterDto>(
        `/data/voters/constituencies/${constituency}.json`
      )

      const mappedVoters = mapConstituencyVoterFromConstituencyVoterDTO(responses.data)

      return Result.success(mappedVoters)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }

  async getVoterCounts() {
    try {
      const response = await axios.get<VoterCount[]>('/data/voters/voter_count.json')
      const voterCounts = response.data
      return Result.success(voterCounts)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }

  async getVoterCountsConstituency(constituency: string) {
    try {
      const response = await axios.get<ConstituencyRegisteredVoter[]>(`/data/voters/voter_count_${constituency}.json`)
      const voterCounts = response.data
      return Result.success(voterCounts)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }

  async getConstituencyVoterCounts() {
    try {
      const response = await axios.get<VoterCount[]>('/data/voters/voter_count.json')
      const voterCounts = response.data
      return Result.success(voterCounts)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }

  async getRegionRegisteredVoters(region: string) {
    try {
      console.log('region', region)
      const response = await axios.get<ConstituencyRegisteredVoter[]>(
        `/data/voters/${region}_registered_voter_change.json`
      )
      const constituencyRegisteredVoters = response.data
      return Result.success(constituencyRegisteredVoters)
    } catch (e) {
      const error = e instanceof Error ? e : new Error('An unknown error occurred')
      console.log(error)
      return Result.failure(error)
    }
  }
}
